import React from 'react';
import './Hero.css';
import dashboardImage from "../image/hero-dashboard.png";

const Hero = () => {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById("pricing");
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>Revolutionize Your Business with KadaiPOS</h1>
          <p>
            The ultimate point of sale solution for modern retailers. Streamline
            operations, increase sales, and grow your business with our intuitive
            platform.
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={scrollToPricing}>
              Start Free Trial
            </button>
            {/* <button className="btn btn-secondary">Watch Demo</button> */}
          </div>
        </div>
        <div className="image-class">
          <img src={dashboardImage} alt="DemoImage" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
